import { createContext, useContext } from 'react';
import { AppDetailContextValue } from './types';

export const AppDetailContext = createContext<AppDetailContextValue | undefined>(undefined);

export function useAppDetailContext() {
  const value = useContext(AppDetailContext);
  if (!value) throw new Error('useAppDetailContext should be used inside a AppDetailContextProvider component.');

  return value;
}
